<app-breadcrumb></app-breadcrumb>

<div class="apv-home">
  <div class="apv-home__content">
    <section class="apv-home__greeting">
      <div class="apv-home__greeting-row">
        <div class="apv-home__greeting-text">
          <h1 class="apv-home__title">{{ greeting.title }}</h1>
          <p class="apv-home__lead">{{ greeting.subtitle }}</p>
        </div>
        <div class="apv-home__greeting-action">
          <ds-button-v2
            emphasis="primary"
            size="m"
            [invert]="true"
            [fullWidth]="true"
            maxWidth="100%"
            [label]="greeting.button"
            [loading]="isStartingSubscription"
            (clicked)="goToSubscription()"
          ></ds-button-v2>
        </div>
      </div>

      <ul class="apv-home__highlights">
        <li *ngFor="let highlight of highlights" class="apv-home__highlight">
          <img class="apv-home__highlight-icon" [src]="highlight.icon" alt="" />
          <p class="apv-home__highlight-text">{{ highlight.text }}</p>
        </li>
      </ul>
    </section>

    <ds-card shadow="l2">
      <section class="apv-home__video">
        <div class="apv-home__video-cover">
          <img class="apv-home__video-image" [src]="videoCover" alt="" />
          <button
            type="button"
            class="apv-home__video-play"
            [attr.aria-label]="video.play"
            (click)="openVideo()"
          >
            <img class="apv-home__video-play-icon" [src]="playIcon" alt="" />
          </button>
        </div>

        <div class="apv-home__video-detail">
          <div class="apv-home__video-tag">
            <ds-tag-pill variant="info" size="s" [label]="video.tag"></ds-tag-pill>
          </div>
          <h2 class="apv-home__card-title">{{ video.title }}</h2>
          <p class="apv-home__card-text">{{ video.text }}</p>
        </div>
      </section>
    </ds-card>

    <ds-card shadow="l2">
      <section class="apv-home__benefits">
        <div class="apv-home__benefits-header">
          <h2 class="apv-home__card-title">{{ benefitsTitle }}</h2>
          <button
            type="button"
            class="apv-home__button apv-home__button--secondary"
            (click)="openLink(links.benefits)"
          >
            {{ benefitsButton }}
            <img class="apv-home__button-icon" [src]="externalIcon" alt="" />
          </button>
        </div>

        <div class="apv-home__benefits-grid">
          <article *ngFor="let benefit of benefits" class="apv-home__benefit">
            <h3 class="apv-home__benefit-title">{{ benefit.title }}</h3>
            <p class="apv-home__benefit-text">{{ benefit.text }}</p>
          </article>
        </div>
      </section>
    </ds-card>

    <section class="apv-home__cta">
      <img class="apv-home__cta-image" [src]="ctaBanner" alt="" />
      <div class="apv-home__cta-content">
        <h2 class="apv-home__cta-title">{{ cta.title }}</h2>
        <p class="apv-home__cta-text">{{ cta.text }}</p>
        <div class="apv-home__cta-action">
          <ds-button-v2
            emphasis="secondary-outlined"
            size="xs"
            [invert]="true"
            [label]="cta.button"
            [loading]="isStartingSubscription"
            (clicked)="goToSubscription()"
          ></ds-button-v2>
        </div>
      </div>
    </section>
  </div>
</div>

<ion-modal
  class="apv-video-modal"
  [isOpen]="showVideo"
  (didDismiss)="closeVideo()"
>
  <ng-template>
    <div class="apv-video-modal__frame">
      <ion-spinner name="crescent"></ion-spinner>
      <iframe
        [src]="videoEmbedUrl"
        [title]="video.title"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </ng-template>
</ion-modal>
